import { Injectable } from '@angular/core';
import { Flujo } from 'src/app/global/interfaces/flujo';
import { FlujosPaso3Service } from 'src/app/global/services/flujos-paso-3.service';



@Injectable()
export class FlujosPaso3Provider extends FlujosPaso3Service {

    datosAgenda: Flujo;
    configuracionCuotas: Flujo;
    cuentaAbono: Flujo;
    firmarDocumentos: Flujo;
    terminosYCondiciones: Flujo;

    constructor() {
        super();
        this.datosAgenda = {
            cargando: true,
            mostrar: false,
            ok: false,
            visible: true
        };

        this.configuracionCuotas = {
            cargando: false,
            mostrar: false,
            ok: false,
            visible: true
        };

        this.cuentaAbono = {
            cargando: false,
            mostrar: false,
            ok: false,
            visible: false
        };

        this.firmarDocumentos = {
            cargando: false,
            mostrar: false,
            ok: false,
            visible: false
        };

        this.terminosYCondiciones = {
            cargando: false,
            mostrar: false,
            ok: false,
            visible: false
        };
    }
}
